module.exports = __webpack_public_path__ + "static/media/profile.03fb6513.jpg";